/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_IntroInputs */

const en_wb_management_intro = /** @type {(inputs: Wb_Management_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here’s what needs attention this week.`)
};

const lv_wb_management_intro = /** @type {(inputs: Wb_Management_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lūk, kam šonedēļ jāpievērš uzmanība.`)
};

/**
* | output |
* | --- |
* | "Here’s what needs attention this week." |
*
* @param {Wb_Management_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_intro = /** @type {((inputs?: Wb_Management_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_intro(inputs)
	return en_wb_management_intro(inputs)
});